var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Form',[_c('h2',[_vm._v("Create your account")]),_c('SignupForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }